import React, {Component} from 'react';
import {Grid, Row, Col, Image} from 'react-bootstrap';
import CameraButton from '../../components/buttons/camera_button/CameraButton';
import './camera-caller.css';
import {connect} from 'react-redux';
import {setImage, setErrorType, setShowError, setLoader} from '../../redux/actionCreators';
import imageProcess from "../../library/ImageProcess";
import step from "../../config/Step";
import {isIOS} from "react-device-detect";
import classnames from 'classnames';
import FooterContainer from '../../components/footer/FooterContainer';
import CircularProgressBarStep from '../../components/circular_progress_bar_step/CircularProgressBarStep';

class CameraCaller extends Component {

    STEPS = [
        step.data.capture_identity_card_front.value,
        step.data.capture_identity_card_back.value,
        step.data.capture_photo.value,
        step.data.capture_circulation_permission.value
    ];

    getImage = async (event, inputFile) => {
        this.props.setLoader(true);
        try {
            const image = await imageProcess.getImageFromFileInput(event, inputFile);
            this.props.setImage(image);
            this.props.nextStep();
        } catch (error) {
            this.props.setErrorType('defaultImage');
        }
    };

    componentDidUpdate(prevProps) {
        if (this.props.windowVisibility !== prevProps.windowVisibility && isIOS && this.props.windowVisibility) {
            this.focusAction();
        }
    }

    focusAction = () => {
        if (this.cameraButton.state.clicked && this.STEPS.includes(this.props.component)) {
            this.intervalId = setTimeout(() => {
                if (this.cameraButton && this.cameraButton.fileInput.files.length === 0) {
                    this.props.setLoader(false);
                    this.cameraButton.setState({clicked: false});
                    clearInterval(this.intervalId);
                }
            }, 2000);
        }

    };

    renderList = (data) => {
        const list = data.split('.');
        console.log(list);
        return list.map((item, index) => {
            if(item !== ''){
                return <li key={index}>{item}</li>
            }
        });
    };

    launchCamera = (inputFile) => {
        inputFile.click();
        this.props.setLoader(true);
    };

    render() {
        let icon;
        let epigraph = '';
        if (this.props.stepInfo.icon) {
            icon = require(`../../resources/images/${this.props.stepInfo.icon}`).default;
        }
        if (this.props.stepInfo.epigraph !== '') {
            epigraph = <h2 className={'epigraph'}>{this.props.stepInfo.epigraph}</h2>
        }
        let buttonText = this.props.stepInfo.buttonText && this.props.stepInfo.buttonText !== ''? this.props.stepInfo.buttonText : 'Continuar';
        return (
            <div
                className={classnames('camera-caller',{[this.props.stepInfo.additionalClass]: this.props.stepInfo.additionalClass && this.props.stepInfo.additionalClass !== '',})}
                onFocus={this.focusAction}
            >
                <Grid>
                    <div className={'content'}>
                        <Row>
                            <Col xs={12}>
                                <div className={'number'}>
                                    <CircularProgressBarStep />
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12}>
                                {epigraph}
                                <h1 className={'title'}>{this.props.stepInfo.title}</h1>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12}>
                                <div className="image">
                                    <Image src={icon}/>
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12}>
                                <p className={'description'}>
                                    {this.props.stepInfo.description}
                                </p>
                            </Col>

                            {this.props.stepInfo.additional &&  this.props.stepInfo.additional !== '' &&
                                <Col xs={12}>
                                    <div className={'alert-box'}>
                                        <span className={'warning-icon'}>!</span> 
                                        <p className={'additional'}>
                                            {this.props.stepInfo.additional}
                                        </p>
                                    </div>
                                </Col>
                            }
                        </Row>
                       <FooterContainer>
                            <CameraButton
                                text={buttonText}
                                getImage={this.getImage}
                                launchCamera={this.launchCamera}
                                ref={cameraButton => this.cameraButton = cameraButton}
                                additionalClass={this.props.stepInfo.additionalClass}
                            />
                       </FooterContainer>
                    </div>
                </Grid>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        image: state.image,
        errorType: state.errorType,
        showError: state.showError,
        stepInfo: state.stepInfo,
        loader: state.loader,
        component: state.component,
        windowVisibility: state.windowVisibility,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        setImage(image, name, extension) {
            dispatch(setImage(image, name, extension));
        },
        setErrorType(errorType) {
            dispatch(setErrorType(errorType));
        },
        setShowError(showError) {
            dispatch(setShowError(showError));
        },
        setLoader(loader) {
            dispatch(setLoader(loader));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(CameraCaller);
